<template>
	<div class="modal-wrapper modal-unpause-subscription-wrapper">
		<div class="unpause-subscription-container bg-white">
			<div class="modal-text">
				<div class="unpause-subscription-modal-title">
					{{ $tc('modals.unpauseSubscription.title') }}
				</div>
				<div class="unpause-subscription-modal-text">
					<p v-html="$tc('modals.unpauseSubscription.mainText')" />
					<p v-html="$tc('modals.unpauseSubscription.mainQuestion')" />
				</div>
			</div>
			<div class="modal-actions-wrap">
				<button class="modal-btn button-pink" @click="onConfirm">
					{{ $tc('modals.unpauseSubscription.confirmButtonText') }}
				</button>
				<button class="modal-btn button-default" @click="onClose">
					{{ $tc('modals.unpauseSubscription.cancelButtonText') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalConfirmUnpauseSubscription',
	mixins: [ModalMixin]
}
</script>

<style lang="scss">
.modal-unpause-subscription-wrapper {
	margin: auto;
	.unpause-subscription {
		&-container {
			width: 420px;
			padding: 32px;
			min-height: 250px;
			border-radius: 8px;
			box-shadow: 0px 4px 21px rgba(0, 0, 0, 0.19);
			.modal-row {
				@include respond-below(phone) {
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
				}
			}
		}
		&-modal-title {
			font-weight: 500;
			font-size: 32px;
			line-height: 38px;
			margin-bottom: 13px;
			text-align: center;
			@include respond-below(phone) {
				font-size: 26px;
				line-height: 32px;
			}
		}
		&-modal-text {
			p {
				font-size: 16px;
				line-height: 21px;
				margin-bottom: 15px;
			}
		}
	}
	.modal-actions-wrap {
		padding-top: 20px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		align-items: center;
		@include respond-below(phone) {
			padding-top: 20px;
		}
	}
}
</style>
